import EyeIcon from 'components/ReusableComponents/Icons/Eye'
import FileIcon from 'components/ReusableComponents/Icons/File'
import ImageIcon from 'components/ReusableComponents/Icons/Image'

import styles from './DocumentTile.module.scss'

/**
 * @typedef {object} Document
 * @property {number} documentId
 * @property {string} name
 * @property {string} path
 * @property {string} downloadablePath
 * @property {null} contentType
 * @property {string} addedOn
 * @property {string} updatedOn
 * @property {string} updatedUser
 * @property {string} addedUser
 * @property {string} kind
 */

/**
 *
 * @typedef {object} Props
 * @property {Document} document
 * @property {() => void} onClick
 *
 * @param {Props} props
 * @returns {React.FC}
 */
export default function DocumentTile(props) {
  const { document, onClick } = props

  const isPdf = document.contentType === 'application/pdf'

  return (
    <div className={styles.tile}>
      {isPdf ? (
        <FileIcon className={styles.pdfImageIcon} />
      ) : (
        <ImageIcon className={styles.pdfImageIcon} />
      )}

      <div className={styles.nameCol}>
        <p>{document.name}</p>
        <p>{document.contentType}</p>
      </div>

      <EyeIcon className={styles.eyeIcon} onClick={onClick} />
    </div>
  )
}
